/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import { persistedDataReducer } from 'connect/reducer';
import { STATE_CATEGORY, StateHandlerRegistry } from 'connect/state/registry';
import languageProviderReducer from 'containers/LanguageProvider/reducer';
import history from 'utils/history';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    language: languageProviderReducer,
    router: connectRouter(history),
    ...injectedReducers,
    data: persistedDataReducer,
    ui: StateHandlerRegistry.singleton.createReducer(STATE_CATEGORY.UI),
  });

  return rootReducer;
}
